import React, { useMemo } from "react";
import { useTicket } from "../../../store/Store";
import { processAdjustmentsData } from "../../general/AppHelpers";
import AdjustmentItem from "../AdjustmentItem";
import { GiftCardIcon } from "../../general/Icons";
import { useTranslation } from "react-i18next";

const GiftCards = () => {
  const { data: ticketData } = useTicket();
  const { t } = useTranslation();

  const { giftCardAdjustments } = useMemo(
    () => processAdjustmentsData(ticketData?.resource?.adjustments),
    [ticketData]
  );

  const giftCardAdjustmentElements = useMemo(() => {
    return giftCardAdjustments?.map(
      ({ adjustment, associatedTaxes }, index) => (
        <AdjustmentItem
          key={`giftcard-${index}`}
          adjustment={adjustment}
          taxes={associatedTaxes}
        />
      )
    );
  }, [giftCardAdjustments]);

  if (!giftCardAdjustmentElements?.length) return null;

  return (
    <div className="py-5" data-testid="gift-cards-container">
      <div className="flex items-center gap-2 mb-2" data-testid="gift-cards-header">
        <GiftCardIcon />
        <h3 className="text-lg font-medium text-black" data-testid="gift-cards-title">
          {t("ticketItemsSections.giftCards")}
        </h3>
      </div>
      <div className="flex flex-col gap-2" data-testid="gift-cards-list">{giftCardAdjustmentElements}</div>
    </div>
  );
};

export default GiftCards;
